export const SEARCH_MODE_BY_STATE = 'state';
export const SEARCH_MODE_BY_ADDRESS = 'address';

// Default to KL
export const DEFAULT_MAP_LOCATION = {
  lat: 3.14567,
  lng: 101.697471
};

export const CAMPAIGN_HOST_AWARD_COOKIES_PREFIX = 'hostsearch_votes';
